import { DxTextBoxComponent, DxTooltipComponent } from 'devextreme-angular';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseComponent } from '@base/component/BaseComponent';
import { Component, Input, ViewChild } from '@angular/core';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { EnumSystemOptions } from '@m4u-angular/core/framework/systemoptions.enum';

class State extends BaseState{
    IsShowPasswordTooltip: boolean;
    PasswordComplexityLen: number;
    PasswordComplexityMinChars: number;
    PasswordComplexityMinDigits: number;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-password-tooltip',
    templateUrl: './password-tooltip.component.html',
    styleUrls: ['./password-tooltip.component.scss']
})
export class PasswordTooltipComponent extends BaseComponent<State> {

    @Input() TextBox: DxTextBoxComponent;
    @ViewChild(DxTooltipComponent) tooltip: DxTooltipComponent;

    constructor(A: ServiceBagService) {
        super(A, 'PasswordTooltipComponent', State);
    }

    override OnInitState() {
        this.State.PasswordComplexityLen = +this.SystemOption(EnumSystemOptions.PasswordComplexityLen);
        this.State.PasswordComplexityMinChars = +this.SystemOption(EnumSystemOptions.PasswordComplexityMinChars);
        this.State.PasswordComplexityMinDigits = +this.SystemOption(EnumSystemOptions.PasswordComplexityMinDigits);
    }

    override OnInitComponent(){
        if(!this.TextBox) return;

        if (!this.TextBox.buttons) { this.TextBox.buttons = []; }
        this.TextBox.buttons.push({
            location: 'after',
            name: 'showTooltip',
            options: {
                icon: 'mdi mdi-information-outline', 
                type: 'normal', 
                onClick: this.OnShowPasswordTooltip
            }
        });
    }

    OnShowPasswordTooltip = () => {
        this.State.IsShowPasswordTooltip = !this.State.IsShowPasswordTooltip;
    }
}
